import EfSection from 'elem/ui/ef-section';
import EfSpec from 'elem/ui/ef-spec';
import css from './index.module.scss';
import { useLang } from '@/i18n';

export default function TheComp() {
    const { t } = useLang('dp3.landing.EU5');
    const configs = {
        title: t('title'),
        desc: t('desc'),
        pc: 'https://websiteoss.ecoflow.com/upload/image/1724296586868/%E5%B7%A5%E4%BD%9C%E7%AB%99.jpg',
        pad: 'https://websiteoss.ecoflow.com/upload/image/1724296586868/%E5%B7%A5%E4%BD%9C%E7%AB%99.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1725178689687/h5-workstation.jpg',
    };

    return (
        <div className={`${css['thecomp']} GtmModuleData-section`} data-section-id={'dp3-EU5'} data-section-title={t('title')}>
            <EfSpec className="spec-x" />
            <EfSection {...configs} hasAnimation={false} />
        </div>
    );
}
